import React, { Component } from 'react';
import _ from 'lodash';

import LoginSession from '../stores/LoginSession';

import AppLayout from './AppLayout';
import MaintainancePage from '../pages/MaintainancePage';
import LoginPage from '../pages/LoginPage';
import RmutiLoginPage from '../pages/RmutiLoginPage';
import SsoCallbackPage from '../pages/SsoCallbackPage';
import SiteSettingStore from '../stores/SiteSettingStore';
import Loading from '../components/Loading';

export default class App extends Component {
	constructor(props){
		super(props)

		this.state = {
			loading: true,
			code_name: "",
			campus_name: ""
		}

		this.renderPage = this.renderPage.bind(this);
	}

	componentDidMount(){
		SiteSettingStore.request({url: 'site_settings/get_code_name'}).then((resp)=>{
      const code_name = _.get(resp.data, 'code_name', "");
      const campus_name = _.get(resp.data, 'name', "");

      this.setState({
      	code_name: code_name,
      	campus_name: campus_name
      });
    }).then(()=>{
    	this.setState({loading: false});
    })
	}

	renderPage(){
		if (window.location.pathname.startsWith('/sso_callback')) {
			return <SsoCallbackPage />;
		}

		const { code_name } = this.state;
		return (
			<div>
				{LoginSession.current ? (
					<AppLayout {...this.props} />
				) : (
					<div>
						{code_name === 'RMUTR' ? (
							<LoginPage />
						) : (
							<RmutiLoginPage {...this.state} />
						)}
					</div>
				)}
			</div>
		)
	}

	render (){
		// return(
		// 	<MaintainancePage />
		// )

		return (
			<div>
				{this.state.loading ? (
					<Loading />
				) : (
					this.renderPage()
				)}
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/layouts/App.js